webpackJsonp([19],{

/***/ 492:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_http_axios__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_format__ = __webpack_require__(440);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var moment = __webpack_require__(315);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FormCadConvenio",
  props: ["dialog", "dados"],
  mixins: [__WEBPACK_IMPORTED_MODULE_2__services_format__["a" /* formata */]],

  data: function data() {
    return {
      convenio: {
        nome: "",
        cnpj: "",
        descricao: "",
        id: ""
      },

      alterar: "",
      cnpjRules: [function (v) {
        return !!v || "Cnpj é requerido";
      }, function (v) {
        return v.length == 14 || "Cnpj   Menor que o padrão";
      }]
    };
  },
  mounted: function mounted() {
    //alert(this.dados);
  },

  computed: {
    computedDateFormatted: function computedDateFormatted() {
      return this.formatDate(this.dataIn);
    }
  },

  watch: {
    dados: function dados(val) {
      if (val) {
        this.convenio.nome = val.nome;
        this.convenio.cnpj = val.cnpj;
        this.convenio.descricao = val.descricao;
        this.convenio.id = val.id;
        this.alterar = "Alterar ";
      } else {
        this.convenio.id = "";
        this.alterar = "";
      }
    },
    dataIn: function dataIn(val) {
      this.dataInFormatted = this.formatDate(this.dataIn);
    },
    dataFim: function dataFim(val) {
      this.dataFimFormatted = this.formatDate(this.dataFim);
    }
  },

  methods: {
    atualizar: function atualizar() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1__services_http_axios__["a" /* HTTP */].put("convenio/" + this.convenio.id, this.convenio).then(function (response) {
        if (response.data.error) {}
        _this.convenio.cnpj = "";
        _this.convenio.nome = "";
        _this.convenio.id = "";
        _this.convenio.descricao = "";

        _this.$emit("gravacaoOkConvenio");
        _this.$emit("fechaDialog");
        _this.$emit("MensagemGravaSucesso", "Gravação executado com sucesso!");
      }).catch(function (e) {
        // console.log("erros:::::" + e.response.data.errors);
        console.log(e.response.data.error);
        if (!Array.isArray(e.response.data.error)) {
          var itens = [];
          for (var prop in e.response.data.error) {
            itens.push(e.response.data.error[prop][0]);
          }

          _this.$emit("getCadConvenio", itens.join(","));
        }
      });
      // this.$parent.selDialog = false;
    },
    salvar: function salvar() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__services_http_axios__["a" /* HTTP */].post("convenio", this.convenio).then(function (response) {
        if (response.data.error) {
          alert("erross:");
        }
        _this2.convenio.cnpj = "";
        _this2.convenio.nome = "";
        _this2.convenio.descricao = "";
        _this2.$emit("gravacaoOkConvenio");
        _this2.$emit("fechaDialog");
        _this2.$emit("MensagemGravaSucesso", "Gravação executado com sucesso!");
      }).catch(function (e) {
        // console.log("erros:::::" + e.response.data.errors);
        console.log(e.response.data.error);
        if (!Array.isArray(e.response.data.error)) {
          var itens = [];
          for (var prop in e.response.data.error) {
            itens.push(e.response.data.error[prop][0]);
          }

          _this2.$emit("getCadConvenio", itens.join(","));
        }
      });
      // this.$parent.selDialog = false;
    },
    parente: function parente() {
      this.$emit("fechaDialog");
    },
    checkStatus: function checkStatus(valor) {
      if (valor) {
        return "Ativo";
      } else {
        return "Inativo ";
      }
    },
    filtrar: function filtrar() {
      this.buscaExtratoCartao(this.dataIn, this.dataFim);
    },
    formata_moeda: function formata_moeda(val) {
      var val1 = val / 100;
      var valor = this.formatar_moeda(val1);
      return valor;
    },
    buscaConvenios: function buscaConvenios() {
      var _this3 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_1__services_http_axios__["a" /* HTTP */].get("grupo/lista/convenio").then(function (response) {
        if (response.data.error) {
          _this3.textSnack = response.data.error;
          _this3.snackbar = true;
        } else {
          //this.extrato =

          _this3.items = response.data;
          _this3.mostraCartoes = true;
        }
        _this3.loading = false;
      });
    },


    //mudar para um mixed
    formatDate: function formatDate(date) {
      if (!date) return null;

      var _date$split = date.split("-"),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + "/" + month + "/" + year;
    },
    parseDate: function parseDate(date) {
      if (!date) return null;

      var _date$split3 = date.split("/"),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          day = _date$split4[0],
          month = _date$split4[1],
          year = _date$split4[2];

      return year + "-" + month.padStart(2, "0") + "-" + day.padStart(2, "0");
    }
  }
});

/***/ }),

/***/ 518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormCadConvenio_vue__ = __webpack_require__(492);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_037b60a4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormCadConvenio_vue__ = __webpack_require__(521);
function injectStyle (ssrContext) {
  __webpack_require__(519)
}
var normalizeComponent = __webpack_require__(103)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FormCadConvenio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_037b60a4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FormCadConvenio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(520);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(299)("6aedee76", content, true, {});

/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(298)(true);
// imports


// module
exports.push([module.i, "#container{margin-top:115px}", "", {"version":3,"sources":["C:/Users/chris/projetos/GrupoPrepago/src/components/FormCadConvenio.vue"],"names":[],"mappings":"AACA,WACE,gBAAkB,CACnB","file":"FormCadConvenio.vue","sourcesContent":["\n#container {\r\n  margin-top: 115px;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 521:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"800px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.alterar)+" Convênio")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Nome","required":""},model:{value:(_vm.convenio.nome),callback:function ($$v) {_vm.$set(_vm.convenio, "nome", $$v)},expression:"convenio.nome"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Cnpj","mask":"##############","rules":_vm.cnpjRules,"counter":"14","hint":"utiliza somente números","required":""},model:{value:(_vm.convenio.cnpj),callback:function ($$v) {_vm.$set(_vm.convenio, "cnpj", $$v)},expression:"convenio.cnpj"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"name":"descricao","label":"Descrição","value":""},model:{value:(_vm.convenio.descricao),callback:function ($$v) {_vm.$set(_vm.convenio, "descricao", $$v)},expression:"convenio.descricao"}})],1)],1)],1),_vm._v(" "),_c('small',[_vm._v("*Campos requeridos")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"terciary"},nativeOn:{"click":function($event){_vm.parente()}}},[_vm._v("Cancelar")]),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"sucesso"},nativeOn:{"click":function($event){_vm.convenio.id==''? _vm.salvar():_vm.atualizar()}}},[_vm._v("Gravar")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/19.d7108dafc05504dc8e9c.js